// Product card colour thumbnails: hovering (or focusing) a colour previews it in the card's main image.
(function () {
  if (window.__cardVariantOptionsInit) return;
  window.__cardVariantOptionsInit = true;

  function getMainImage(link) {
    var card = link.closest('.card-wrapper');
    if (!card) return null;
    return card.querySelector('.card__media img');
  }

  function preview(link) {
    var img = getMainImage(link);
    if (!img || !link.dataset.previewSrc) return;
    if (!img.dataset.originalSrc) {
      img.dataset.originalSrc = img.getAttribute('src') || '';
      img.dataset.originalSrcset = img.getAttribute('srcset') || '';
    }
    img.setAttribute('srcset', link.dataset.previewSrcset || '');
    img.setAttribute('src', link.dataset.previewSrc);
    var list = link.closest('.card-variant-options__list');
    if (list) {
      list.querySelectorAll('.is-active').forEach(function (el) { el.classList.remove('is-active'); });
    }
    link.classList.add('is-active');
  }

  function restore(link) {
    var img = getMainImage(link);
    if (!img || !img.dataset.originalSrc) return;
    img.setAttribute('srcset', img.dataset.originalSrcset);
    img.setAttribute('src', img.dataset.originalSrc);
    link.classList.remove('is-active');
  }

  document.addEventListener('mouseover', function (e) {
    var link = e.target.closest && e.target.closest('.card-variant-options__value--image');
    if (link) preview(link);
  });

  document.addEventListener('mouseout', function (e) {
    var link = e.target.closest && e.target.closest('.card-variant-options__value--image');
    if (link && !link.contains(e.relatedTarget)) restore(link);
  });

  document.addEventListener('focusin', function (e) {
    var link = e.target.closest && e.target.closest('.card-variant-options__value--image');
    if (link) preview(link);
  });

  document.addEventListener('focusout', function (e) {
    var link = e.target.closest && e.target.closest('.card-variant-options__value--image');
    if (link) restore(link);
  });
})();
